export default __webpack_public_path__ + "static/media/acct-payroll-list.8dc1ee09.png";